import React from 'react';
import { Link } from 'react-router-dom'
import CloudinaryAdvancedImage from '@common/utils/CloudinaryAdvancedImage';

function Fabric({ title, desc, link, mainImage, supportingImage }) {

  return (
    <div className='bs-fabric'>
      <div className='bs-fabric__media-wrap'>
        <div className='bs-fabric__primary-image-wrap'>
          <CloudinaryAdvancedImage imagePublicId={mainImage} className='bs-section-banner__image' type="full-width-feature-banner" />
        </div>
        <div className='bs-fabric__secondary-image-wrap'>
          <CloudinaryAdvancedImage imagePublicId={supportingImage} className='bs-section-banner__image' type="full-width-feature-banner" />
        </div>
      </div>
      <div className='bs-fabric__info-wrap'>
        <h3 className='bs-fabric__title'>{title}</h3>
        <p className='bs-fabric__desc'>{desc}</p>
        <Link
          to={link}
          className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-large bs-section-banner__action'
        >
          explore fabrics
        </Link>
      </div>
    </div>
  )
}

export default Fabric